import React from 'react';
import { Section } from '../ui/Section';
import { SectionTitle, Accent } from '../ui/SectionTitle';
import { HighlightQuote } from '../ui/HighlightQuote';
import { suspects, triedThings } from '../../data/content';
import { images } from '../../data/images';
export function ProblemSection() {
  return <Section tone="surface" data-id="element-176" data-mp="dj4upcb0p7yn">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-177" data-mp="dibvcwee1kqj">
        <div className="lg:col-span-7" data-id="element-178" data-mp="3vozzaixpc1um">
          <SectionTitle data-id="element-179" data-mp="3vnyevnusq308">
            Si estás haciendo esfuerzo pero <Accent data-id="element-180" data-mp="3m8l139dufsi">no ves cambios</Accent>, esto es para ti.
          </SectionTitle>

          <div className="mt-10 space-y-8 text-lg leading-relaxed text-muted" data-id="element-181" data-mp="3lrll6pz93p5h">
            <p className="text-xl text-white" data-id="element-182" data-mp="3ltoky1q7gwne">Tal vez ya estás intentando mejorar.</p>

            <ul className="flex flex-wrap gap-2.5" aria-label="Lo que ya estás haciendo" data-id="element-183" data-mp="3qsj0musvm53a">
              {triedThings.map(t => <li key={t} className="rounded-md border border-line bg-ink px-4 py-2 text-base text-white" data-id="element-184" data-mp="1oytha2kd04yx">
                  {t}
                </li>)}
            </ul>

            <p className="font-display text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-185" data-mp="1iorkkfxkym9h">
              Pero sigues sintiendo que algo no está funcionando.
            </p>

            <div data-id="element-186" data-mp="1whz9u0y6v5o0">
              <p data-id="element-187" data-mp="1set9tb1o6apz">No sabes si el problema es…</p>
              <ul className="mt-4 flex flex-wrap gap-x-4 gap-y-2" data-id="element-188" data-mp="1sf30z1yganx9">
                {suspects.map(s => <li key={s} className="text-white" data-id="element-189" data-mp="14p8panpvb5el">
                    {s}
                    <span className="ml-4 text-brand" aria-hidden="true" data-id="element-190" data-mp="zr74nycsmy10">
                      /
                    </span>
                  </li>)}
                <li className="text-white" data-id="element-191" data-mp="18qtz2073v3kk">o simplemente que no tienes un plan claro.</li>
              </ul>
            </div>

            <p className="border-t border-line pt-8 text-xl text-white" data-id="element-192" data-mp="2p3sk0vltdmkt">
              Y ahí es donde entra <span className="text-brand" data-id="element-193" data-mp="2k4pbv2ajf08m">este diagnóstico.</span>
            </p>
          </div>
        </div>

        <div className="lg:col-span-5" data-id="element-194" data-mp="1hrjdobecy79h">
          <figure className="overflow-hidden rounded-lg border border-line bg-ink lg:sticky lg:top-28" data-id="element-195" data-mp="1hunlrjuy1n5f">
            <img src={images.problem} alt="Sebastian Vargas, coach fitness y personal trainer, en el gimnasio" className="aspect-[4/5] w-full object-cover object-[55%_25%]" data-id="element-196" data-mp="1qszmwftfs3c4" />
            <figcaption className="border-t-2 border-brand p-6 sm:p-7" data-id="element-197" data-mp="z2mhu33bb6p5">
              <p className="text-lg leading-relaxed text-white" data-id="element-198" data-mp="133etf2znpnol">
                Soy <span className="font-semibold" data-id="element-199" data-mp="133oi8n8ytosp">Sebastian Vargas</span>, coach fitness y personal trainer. Ayudo a
                personas ocupadas, especialmente latinos en Estados Unidos, a transformar su cuerpo sin dietas extremas
                ni rutinas imposibles.
              </p>
              <p className="mt-4 leading-relaxed text-muted" data-id="element-200" data-mp="fdax7gossq7m">
                Mi enfoque es simple: entender tu vida real, crear un plan que puedas cumplir y acompañarte con
                entrenamiento, nutrición y seguimiento para que dejes de sentirte perdido/a.
              </p>
            </figcaption>
          </figure>
        </div>
      </div>

      <HighlightQuote size="lg" className="mt-20" data-id="element-201" data-mp="2up4hcomq2kq">
        No te falta intención. <span className="text-brand" data-id="element-202" data-mp="2x2z5kfedcrr">Te falta dirección.</span>
      </HighlightQuote>
    </Section>;
}